import { NavLink } from 'react-router-dom';
import { themeGet } from '@styled-system/theme-get';
import styled from 'styled-components/macro';

export const StyledNavigationList = styled.nav`
  display: flex;
`;

export const StyledNavigationItem = styled.li`
  display: flex;
  align-items: center;
  text-align: center;

  &:not(:last-child) {
    margin-right: 48px;
  }
`;

export const StyledNavigationLink = styled(NavLink)`
  font-style: normal;
  display: flex;
  align-items: center;
  text-align: center;
  text-decoration: none;

  color: ${themeGet('colors.body.text')};
  font-family: ${themeGet('fonts.menu')};
  font-size: ${themeGet('fontSizes.up')}px;
  font-weight: ${themeGet('fontWeights.regular')};
  transition: none;

  &.active {
    font-weight: ${themeGet('fontWeights.semi')};
  }

  &:hover:not(.active) {
    color: ${themeGet('colors.menu.hover')};
  }
`;
